import React from 'react'
import classNames from 'classnames'

function MediaContent({ children, modifierClasses = [] }) {
  const mediaContentClasses = classNames(
    'media__content',
    modifierClasses
  )
  return (
    <div className={mediaContentClasses}>{children}</div>
  )
}
export default MediaContent

